.sn-dynamic-content {
  h2 {
    font-size: map-get($font-sizes, 2xl); // 24px (heading-4-sm)
    line-height: map-get($line-heights, lg); // 140% (heading-4-sm)

    @include desktop {
      font-size: map-get($font-sizes, 3xl); // 32px (heading-4-lg)
      line-height: map-get($line-heights, xl); // 130% (heading-4-lg)
    }
  }

  ul {
    list-style: disc inside;
    margin: 0 0 var(--spacing-md);
    padding-left: revert; // Restore default browser padding if it was reset above
  }
}
